"use client";

import { c as _c } from "react/compiler-runtime";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import type { ThemeProviderProps } from "next-themes";
import { NuqsAdapter } from "nuqs/adapters/next/app";
import type { ReactNode } from "react";
import { getQueryClient } from "../lib/react-query/get-query-client";
import { LanguageProvider } from "./language-provider";
import { ThemeProvider } from "./theme-provider";
export function GlobalProviders(t0) {
  const $ = _c(10);
  const {
    children,
    translations,
    themeConfig
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getQueryClient();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const queryClient = t1;
  let t2;
  if ($[1] !== children || $[2] !== translations) {
    t2 = <LanguageProvider translations={translations}>{children}</LanguageProvider>;
    $[1] = children;
    $[2] = translations;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2 || $[5] !== themeConfig) {
    t3 = <NuqsAdapter><ThemeProvider {...themeConfig}>{t2}</ThemeProvider></NuqsAdapter>;
    $[4] = t2;
    $[5] = themeConfig;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ReactQueryDevtools initialIsOpen={true} />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3) {
    t5 = <QueryClientProvider client={queryClient}>{t3}{t4}</QueryClientProvider>;
    $[8] = t3;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}